export default __webpack_public_path__ + "static/avatar-andy-gray3-5803d9e361d64e4d626015226c88beb9.jpg";